/**
 * In-flight highlight "Tell me more" asks, by the `correlationId` we sent them with.
 *
 * GAIA answers them like a question the expert typed, so the timeline's reply listeners would render them.
 * The echoed `correlationId` is the only marker we get; those listeners skip anything registered here.
 */
const pending = new Set<string>();

/**
 * Bounds the set when a reply never arrives. Deliberately the only cleanup besides the reply itself: clearing
 * on a timeout would let a late reply through to the timeline as a message the expert never asked for there.
 */
const MAX_PENDING = 50;

export const registerHighlightAssistRequest = (correlationId: string) => {
    if (pending.size >= MAX_PENDING) {
        // Set preserves insertion order, so this is the oldest.
        const oldest = pending.values().next().value;
        if (oldest) pending.delete(oldest);
    }
    pending.add(correlationId);
};

export const isHighlightAssistRequest = (correlationId?: string) => !!correlationId && pending.has(correlationId);

export const clearHighlightAssistRequest = (correlationId?: string) => {
    if (correlationId) pending.delete(correlationId);
};
